var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LogoImage"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.source}}),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.source))])])}
var staticRenderFns = []

export { render, staticRenderFns }